import Monitoring from '../Monitoring/Monitoring';

export default function Body() {
    return(
        <main>
            <div className="xbox__body servers">
                <Monitoring titleEnabled={false}/>
            </div>
        </main>
    )
}